import { Injectable } from '@angular/core';

import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, withLatestFrom, catchError, map, filter, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { UsersListService } from '@apps/auth/domain/users-list.service';
import { IAuroraState } from '@apps/aurora.state';
import { User } from '@apps/auth/domain/models/back';

import * as fromBackAuthStoreActions from './users-external.actions';
import { getUsersExternalIsDataValid, getUsersExternalQueryString } from './users-external.selectors';

@Injectable()
export class BackAuthUsersExternalEffects
{
    constructor (
        private actions: Actions,
        private usersListService: UsersListService,
        private store: Store<IAuroraState>
    )
    { }

    backAuthUsersExternalODataRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromBackAuthStoreActions.BackAuthUsersExternalODataRequested),
                    withLatestFrom(
                        this.store.select(getUsersExternalIsDataValid),
                        this.store.select(getUsersExternalQueryString),
                        (_, valid, qs) => ({
                            valid,
                            qs
                        })
                    ),
                    filter((params) => !params.valid),
                    switchMap((params) =>
                        this.usersListService.getUsers(params.qs)
                            .pipe(
                                map((users: User[]) =>
                                    fromBackAuthStoreActions.BackAuthUsersExternalODataLoaded({ users })
                                ),
                                catchError((err: any) =>
                                    of(fromBackAuthStoreActions.BackAuthUsersExternalODataFailed({ err }))
                                )
                            )
                    )
                ),
        { dispatch: true }
    );
}
